// @flow

import React, { Suspense } from 'react';

import LoadingIndicator from '../../components/LoadingIndicator';

const Analytics = React.lazy(() => import('./index'));

const AnalyticsLoadable = () => (
  <div>
    <Suspense fallback={<LoadingIndicator />}>
      <Analytics />
    </Suspense>
  </div>
);

export default AnalyticsLoadable;
